import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { position } from 'polished';
import { withRouter } from 'react-router';
import { color } from '@deerplusofficial/pos-helper';
import { Button } from '@deerplusofficial/pos-components';
import { PageTitle } from '../../components';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  ${position('absolute', '0', null, null, '0')};
`;

const Wrapper = styled.div`
  margin: auto;
  padding: 24px;
  width: 100%;
  max-width: 360px;
  text-align: center;
  color: ${color.text.title};
`;

const Code = styled.div`
  margin-bottom: 16px;
  font-size: 80px;
  color: ${color.primary};
`;

const Title = styled.div`
  font-size: 18px;
`;

const BackButton = styled(Button)`
  margin-top: 32px;
  width: 100%;
`;

class PageNotFound extends PureComponent {
  static propTypes = {
    history: PropTypes.shape(),
  };

  static defaultProps = {
    history: {},
  };

  onButtonClick = () => this.props.history.goBack();

  render() {
    return (
      <Container>
        <PageTitle>Page Not Found</PageTitle>
        <Wrapper>
          <Code>404</Code>
          <Title>您所訪問的內容未找到！</Title>
          <p>您正在尋找的這個頁面不存在</p>
          <BackButton primary onClick={this.onButtonClick}>
            回前頁
          </BackButton>
        </Wrapper>
      </Container>
    );
  }
}

export default withRouter(PageNotFound);



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/PageNotFound.js